var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsNewlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 20.82c.15.82-.5 1.57-1.35 1.57-.64 0-1.17-.43-1.31-1.07l-1.39-6.08h-.6a.32.32 0 0 1-.32-.32V5.54c0-.18.14-.32.32-.32h4.2c.17 0 .31.14.31.32v9.42c0 .18-.14.32-.32.32h-.46l.92 5.54ZM21.35 2.87c-3.2 2.17-6.58 2.74-9.78 3.02v8.68c3.24.28 6.62.89 9.78 3.02.68.46 1.32.14 1.32-.82V3.7c0-.93-.64-1.28-1.32-.82ZM1.33 10.23a4.7 4.7 0 0 0 3.88 4.62V5.61a4.75 4.75 0 0 0-3.88 4.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewlarge);
export default __webpack_public_path__ + "static/media/whatsNew.large.39d9a1576ba4c129aceaae26cdaf6da2.svg";
export { ForwardRef as ReactComponent };